// extracted by mini-css-extract-plugin
module.exports = {"networkConfig":"NewConfig_networkConfig__1l9Tx","marginTop":"NewConfig_marginTop__2n9EY"};